module.exports = __webpack_public_path__ + "static/automatic-ai_3-c2dcd792056a8cfb5e7a881ef0b8e3d8.jpg";